import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { queryClient } from "@/shared/lib/react-query";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";

export const useSectionThreeActions = (
  mainJournalData: any,
  search?: string,
) => {
  const { mutate: deleteSectionEntry } = $journalApi.useMutation(
    "delete",
    "/api/v1/journals/section-three/items/{itemNoVersionId}",
    {
      body: (data: any) => data,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection3({
            sectionThreeListId:
              mainJournalData?.mainJournal?.section3?.sectionListId || "",
            search,
          }).queryKey,
        });
      },
      onError: (error: any) => {
        const status = error?.response?.status || error?.status;
        const description = status === 409
          ? NOTIFICATION_MESSAGES.ENTRY_DELETE_RELATED_DATA_ERROR // "Есть связанные данные, удаление невозможно выполнить"
          : NOTIFICATION_MESSAGES.ENTRY_DELETE_NOT_POSSIBLE; // "Не удалось удалить запись"
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_DELETE_ERROR, // "Ошибка при удалении записи"
          description,
        });
      },
    },
  );

  return {
    deleteSectionEntry,
  };
};
